import clsx from 'clsx'
import { FC, ReactNode } from 'react'
import { WithChildren } from '../react18MigrationHelpers'

type Props = {
  className?: string
  children?: ReactNode
}

export const KTFooter: FC<Props & WithChildren> = ({ className, children }) => {
  return <div className={clsx('card-footer', className && className)}>{children}</div>
}
